// extracted by mini-css-extract-plugin
export default {"button_section":"button_button_section__WK-My"};